// extracted by mini-css-extract-plugin
export default {"button":"MessageButton_button__fUIbz","label":"MessageButton_label__QYGQM"};